// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"wm_a bie_b"};